// extracted by mini-css-extract-plugin
export default {"screenLock":"ScreenLock_screenLock__dhDEd","screenLockWrapper":"ScreenLock_screenLockWrapper__hnfL5"};